/*
 *  Interface représentant une commande client telle qu'utilisée dans l'application React et l'application API
 */

import { StatusConfig } from '@common/components/StatusCard/StatusCard';
import { faBox, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { ProjectData } from 'features/projects';
import { UserData } from 'features/users';

export interface CustomerOrderData {
	// Obligatoires
	id: number;
	referenceNumber: string;
	// Champs simples
	orderDate?: Date;
	amount?: number;
	status?: string;
	// Relations
	project?: ProjectData | null;
	quote?: { id: number; referenceNumber: string } | null;
	// Métadonnées
	createdAt?: Date;
	createdBy?: UserData | null;
}

export const CUSTOMER_ORDER_STATUS_CONFIG: StatusConfig = {
	steps: [
		{
			key: 'DRAFT',
			label: 'Brouillon',
			icon: faBox,
			color: 'bg-blue-600 text-white',
			textColor: 'text-blue-600',
		},
		{
			key: 'RECEIVED',
			label: 'Reçue',
			icon: faCircleCheck,
			color: 'bg-green-600 text-white',
			textColor: 'text-green-600',
		},
	],
	transitions: {
		DRAFT: [{ to: 'RECEIVED', label: 'Valider', type: 'main' }],
		RECEIVED: [],
	},
};
